
(function() {
  var result = { translations: { "ca-es": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} dies", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m" } }, "dateTime": { "quarterAndYear": "T {{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ca-es": "static-7.1085"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1085",
    "ar-eg": "static-7.1085",
    "bg": "static-7.1085",
    "bn": "static-7.1085",
    "ca-es": "static-7.1085",
    "cs": "static-7.1085",
    "da": "static-7.1085",
    "de": "static-7.1085",
    "el": "static-7.1085",
    "en-gb": "static-7.1085",
    "en": "static-7.1085",
    "es-mx": "static-7.1085",
    "es": "static-7.1085",
    "et": "static-7.1085",
    "fi": "static-7.1085",
    "fr-ca": "static-7.1085",
    "fr": "static-7.1085",
    "he-il": "static-7.1085",
    "hi": "static-7.1085",
    "hr": "static-7.1085",
    "hu": "static-7.1085",
    "id": "static-7.1085",
    "it": "static-7.1085",
    "ja": "static-7.1085",
    "ko": "static-7.1085",
    "lt": "static-7.1085",
    "ms": "static-7.1085",
    "nl": "static-7.1085",
    "no": "static-7.1085",
    "pl": "static-7.1085",
    "pt-br": "static-7.1085",
    "pt-pt": "static-7.1085",
    "ro": "static-7.1085",
    "ru": "static-7.1085",
    "sk": "static-7.1085",
    "sl": "static-7.1085",
    "sv": "static-7.1085",
    "th": "static-7.1085",
    "tl": "static-7.1085",
    "tr": "static-7.1085",
    "uk": "static-7.1085",
    "vi": "static-7.1085",
    "x-pseudo": "static-7.1085",
    "zh-cn": "static-7.1085",
    "zh-hk": "static-7.1085",
    "zh-tw": "static-7.1085"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ca-es', {version: 'static-7.1085'}); }
})();


